import { Logo } from "./Logo";

export const inputCls = "w-full rounded-2xl px-4 py-3 bg-[var(--surface)] bg-[var(--bg-2)] border border-[var(--surface-border)] text-[var(--ink)] placeholder:text-[var(--muted)] outline-none focus:border-[var(--pink)] focus:shadow-[0_0_16px_-2px_var(--glow-pink)] transition-shadow";

export default function AuthShell({ title, highlight, sub, children, testid }) {
  return (
    <div data-testid={testid} className="max-w-md mx-auto px-5 pt-14">
      <div className="glass rounded-[2rem] p-8 sm:p-10 shadow-[0_30px_80px_-30px_var(--glow-pink)]">
        <div className="flex justify-center"><Logo className="h-14" /></div>
        <h1 className="font-display text-3xl font-bold text-center mt-5">{title} <span className="neon-text">{highlight}</span></h1>
        {sub && <p className="text-sm text-[var(--muted)] text-center mt-2">{sub}</p>}
        <div className="mt-7">{children}</div>
      </div>
    </div>
  );
}
